import {Component, OnInit} from '@angular/core';
import {AdminService} from '../../../services/admin.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-standard-dissemination',
  templateUrl: './standard-dissemination.component.html',
  styleUrls: ['./standard-dissemination.component.css']
})
export class StandardDisseminationComponent implements OnInit {
  standardsList: any[] = [];
  currentGroup: any;
  selectedStandard = null;
  errorMessage: string;

  isLoaded = false;
  allGroupPositions: any[] = [];
  selectedPositions: any[] = [];
  originalSelectedPositions: any[] = [];
  saveDisabled: boolean;

  failedLoadingGroup = false;
  failedRetrievingStandards = false;
  success = false;

  constructor(private adminService: AdminService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.isLoaded = false;
    // GET GROUP BY ID
    this.adminService.getGroupByID(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.currentGroup = response.body;
          this.allGroupPositions = [];
          // GET POSITIONS FROM USERS
          this.currentGroup.activeUsers.forEach(au => {
            if (this.allGroupPositions.length > 0) {
              let exist = false;
              this.allGroupPositions.forEach(p => {
                if (p.id === au.position.id) {
                  exist = true;
                }
              });
              if (!exist) {
                this.allGroupPositions.push(au.position);
              }
            } else {
              this.allGroupPositions.push(au.position);
            }
          });

          // GET ALL STANDARDS
          this.adminService.getAllStandardsGroupWithoutSort().subscribe(
            (res: any) => {
              if (res.status === 200) {
                const standardsLite = res.body;
                standardsLite.forEach(s => {
                  if (s.hasOwnProperty('groupsWithPositions')) {
                    if (s.groupsWithPositions !== undefined) {
                      this.standardsList.push(s);
                    }
                  }
                });

                this.isLoaded = true;
                this.selectedStandard = this.standardsList[0];
                this.selectStandard(this.standardsList[0].id);

              }
              if (res.status === 204) {
                this.failedRetrievingStandards = true;
                this.errorMessage = 'No standards for distributing';
                this.isLoaded = true;
              }
            },
            () => {
              this.failedRetrievingStandards = true;
              this.isLoaded = true;
            }
          );
        }
      },
      () => {
        this.failedLoadingGroup = true;
        this.isLoaded = true;
      }
    );
  }

  selectPosItem(pos) {
    this.success = false;
    if (!this.selectedPositions.includes(pos)) {
      this.selectedPositions.push(pos);
    } else {
      const indexPos = this.selectedPositions.indexOf(pos);
      this.selectedPositions.splice(indexPos, 1);
    }
  }

  selectStandard(standardID) {
    this.success = false;
    this.selectedStandard = this.standardsList.find(value => value.id === standardID);
    this.selectedPositions = [];
    this.originalSelectedPositions = [];

    if (this.selectedStandard) {
      if (this.selectedStandard.hasOwnProperty('groupsWithPositions')) {
        if (this.selectedStandard.groupsWithPositions !== undefined) {
          if (this.selectedStandard.groupsWithPositions !== null) {
            this.selectedStandard.groupsWithPositions.forEach(item => {
              if (item.group.id === this.currentGroup.id) {
                if (item.positions.length > 0) {
                  item.positions.forEach(it => {
                    this.allGroupPositions.forEach(pos => {
                      if (it.id === pos.id) {
                        this.selectedPositions.push(pos);
                      }
                    });
                  });
                } else {
                  this.originalSelectedPositions = [];
                  this.selectedPositions = [];
                }
              }

            });
          } else if (this.selectedStandard.groupsWithPositions === null) {
            this.originalSelectedPositions = [];
            this.selectedPositions = [];
          }
        }
      }
    }
    // Запоминаем какие позиции выбраны
    if (this.selectedPositions.length > 0) {
      this.selectedPositions.forEach(sp => {
        this.originalSelectedPositions.push(sp);
      });
    } else {
      this.originalSelectedPositions = [];
    }
  }

  submitForm() {
    let positions = [];

    if (this.selectedPositions.length > 0) {
      this.selectedPositions.forEach(p => {
        positions.push({id: p.id});
      });
    } else {
      positions = [];
    }

    const dissemination = {
      standardId: this.selectedStandard.id,
      groupId: this.currentGroup.id,
      positions: positions
    };

    this.adminService.disseminateStandard(dissemination, this.selectedStandard.id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          const index = this.standardsList.indexOf(this.selectedStandard);
          this.standardsList[index] = response.body;

          this.selectedStandard = this.standardsList[0];
          this.selectStandard(this.selectedStandard.id);

          this.success = true;
          this.saveDisabled = false;
        }
      },
      () => {
        this.saveDisabled = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/standard-dissemination/standard-dissemination.component.ts